import { $admin } from "@/utils/https.js";

// 创建售后工单
export function createAfterSaleBucket(data) {
    return $admin().post(`/api/admin/after_sales/bucket`, data);
}

// 获取工单列表
export function getAfterSalesBuckets(params) {
    return $admin().get(`/api/admin/after_sales/bucket`, { params });
}

// 获取node历史工单列表
export function getAfterSalesBucketLogs(node_id) {
    return $admin().get(`/api/admin/after_sales/bucket/node/${node_id}/log`);
}

// 获取工单统计分析
export function getAfterSalesBucketStat(params) {
    return $admin().get(`/api/admin/after_sales/bucket/stat`, { params });
}

// 获取工单详情
export function getAfterSalesBucket(id) {
    return $admin().get(`/api/admin/after_sales/bucket/${id}`);
}

// 更新工单
export function updateAfterSalesBucket(id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}`, data);
}

// 更新工单类型
export function updateAfterSalesBucketType(id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/type`, data);
}

// 设置工单外勤状态
export function updateAfterSalesBucketIsOut(id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/is_out`, data);
}

// 删除工单
export function deleteAfterSalesBucket(id) {
    return $admin().delete(`/api/admin/after_sales/bucket/${id}`);
}

// 指派工单
export function assignAfterSalesBucket(id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/assign`, data);
}

// 移出指派
export function rmAssignAfterSalesBucket(id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/rm_assign`, data);
}

// 接单
export function acceptAfterSalesBucket(id) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/accept`);
}

// 关闭工单
export function closeAfterSalesBucket(id) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/close`);
}

// 提醒
export function remindAfterSalesBucket(id) {
    return $admin().get(`/api/admin/after_sales/bucket/${id}/alert`);
}

// 更新工单描述
export function updateAfterSalesBucketDesc(id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/desc`, data);
}

// 完成工单
export function finishAfterSalesBucket(id) {
    return $admin().put(`/api/admin/after_sales/bucket/${id}/finish`);
}

// 获取工单列表统计
export function getAfterSalesBucketCount(params) {
    return $admin().get(`/api/admin/after_sales/bucket/count`, { params });
}

// 获取我的工单列表
export function getMyAfterSalesBuckets(params) {
    return $admin().get(`/api/admin/after_sales/bucket/i`, { params });
}

// 获取待处理工单列表
export function getPendingAfterSalesBuckets(params) {
    return $admin().get(`/api/admin/after_sales/bucket/pending`, { params });
}

// 获取待处理工单统计
export function getPendingAfterSalesBucketCount(params) {
    return $admin().get(`/api/admin/after_sales/bucket/pending/count`, { params });
}

// 流程
// 获取工单流程列表
export function getWorkflowProcessList(params) {
    return $admin().get(`/api/admin/after_sales/process`, { params });
}

// 创建工单流程
export function createWorkflowProcess(data) {
    return $admin().post(`/api/admin/after_sales/process`, data);
}

// 获取工单流程详情
export function getWorkflowProcessDetail(id) {
    return $admin().get(`/api/admin/after_sales/process/${id}`);
}

// 更新工单流程
export function updateWorkflowProcess(id, data) {
    return $admin().put(`/api/admin/after_sales/process/${id}`, data);
}

// 删除工单流程
export function deleteWorkflowProcess(id) {
    return $admin().delete(`/api/admin/after_sales/process/${id}`);
}

//售后工单-新建零件消耗
export function createAfterSalesItem(bucket_id, data) {
    return $admin().post(`/api/admin/after_sales/bucket/${bucket_id}/goods`, data);
}

//售后工单-获取零件消耗列表
export function getAfterSalesItemList(bucket_id) {
    return $admin().get(`/api/admin/after_sales/bucket/${bucket_id}/goods`);
}

//售后工单-删除零件消耗
export function deleteAfterSalesItem(bucket_id, id) {
    return $admin().delete(`/api/admin/after_sales/bucket/${bucket_id}/goods/${id}`);
}

//售后工单-更新零件消耗
export function updateAfterSalesItem(bucket_id, id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${bucket_id}/goods/${id}`, data);
}

//创建快递信息
export function createAfterSalesExpress(bucket_id, data) {
    return $admin().post(`/api/admin/after_sales/bucket/${bucket_id}/express`, data);
}

//创建售后收费单
export function createAfterSalesBill(bucket_id, data) {
    return $admin().post(`/api/admin/after_sales/bucket/${bucket_id}/charge`, data);
}
//更新售后收费单
export function updateAfterSalesBill(bucket_id, id, data) {
    return $admin().put(`/api/admin/after_sales/bucket/${bucket_id}/charge/${id}`, data);
}
//获取所有的售后收费单列表
export function getAfterSalesBillList(params) {
    return $admin().get(`/api/admin/after_sales/bucket/charge`, { params });
}

//删除售后收费单
export function deleteAfterSalesBill(bucket_id, id) {
    return $admin().delete(`/api/admin/after_sales/bucket/${bucket_id}/charge/${id}`);
}

//获取单个售后收费单
export function getAfterSalesBill(bucket_id, id) {
    return $admin().get(`/api/admin/after_sales/bucket/${bucket_id}/charge/${id}`);
}
//发起支付请求
export function payAfterSalesBill(bucket_id, id, data) {
    return $admin().post(`/api/admin/after_sales/bucket/${bucket_id}/charge/${id}/pay`, data);
}
//检查支付状态
export function checkPayAfterSalesBill(bucket_id, id) {
    return $admin().get(`/api/admin/after_sales/bucket/${bucket_id}/charge/${id}/pay-check`);
}
